import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { ToastService } from '../../../services/toast.service';
import { ProfileService } from 'src/app/core/services/profile/profile.service';
import { LocalStorageService } from 'src/app/core/services/localStorage/local-storage.service';
import { ValidationService } from 'src/app/core/validations/ValidationService';
import { InputControlMessagesComponent } from 'src/app/core/validations/Input-control-messages.component';
import { InputControls } from 'src/app/core/validations/InputControls';

@Component({
  selector: 'app-profile',
  imports: [
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatTooltipModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule, RouterModule, MaterialModule, FormsModule,
    InputControlMessagesComponent
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {
  profileForm: FormGroup;
  profilePicture: any;
  title: any = 'title'
  userId: any;
  profileDetail: any;
  profileImageUrl: any;
  inputControls: any = InputControls;

  constructor(
    private fb: FormBuilder,
    private toastService: ToastService,
    private profileService: ProfileService,
    private localStorageService: LocalStorageService,
    public dialogRef: MatDialogRef<ProfileComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {
    this.userId = this.localStorageService.getUserId();
  }

  ngOnInit() {
    this.initForm();
    this.getProfileDetailById();
  }

  getProfileDetailById() {
    this.profileService.getProfileById(this.userId).subscribe({
      next: (res: any) => {
        console.log('profile res', res)
        if (res.isSuccess) {
          this.profileDetail = res.item;
          if (this.profileDetail) {
            this.setFormValue(this.profileDetail);
          }
        }
      },
      error: (error: any) => {
        console.log(error)
      }
    })
  }

  initForm() {
  this.profileForm = this.fb.group({
    firstName: ['', [ValidationService.required]],
    lastName: ['', [ValidationService.required]],
    userName: [''],
    email:['']
  })
}

  setFormValue(detail: any) {
    this.profileForm.get('firstName')?.setValue(detail.firstName);
    this.profileForm.get('lastName')?.setValue(detail.lastName);
    this.profileForm.get('email')?.setValue(detail.email)
    this.profileImageUrl = detail.imgUrl;
  }

  onCancel() {

  }

  save() {
  if (this.profileForm.invalid) {
    this.profileForm.markAllAsTouched();
    return;
  }

  const formValue = this.profileForm.value;
  const payload = {
    firstName: formValue.firstName,
    lastName: formValue.lastName,
    user: this.userId,
    imgUrl: this.profileImageUrl
  }

  this.profileService.updateProfile(payload, this.userId).subscribe({
    next: ((res: any) => {
      if (res.isSuccess) {
        this.localStorageService.setProfileImg(this.profileImageUrl);
        this.toastService.successToast('Profile updated successfully');
        this.dialogRef.close();
      }
    }),
   error: ((error: any) => {
  console.log(error)
}),
    complete: (() => { })
  })
}


  uploadFile(event: any, fileInput: any) {
    const file = event.target.files[0];
    console.log('fileInput', file)
    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024); // Convert size to MB
      if (file.size > 10 * 1024 * 1024) {
        this.toastService.errorToast('File size should be less then 10 MB');
        // this.toast

      } else {
        // this.isLoading[index] = true;
        const fileName = `${Date.now()}_${file.name}`
        const formData = new FormData();
        formData.append('media', file);
        this.profileService.uploadProfile(formData).subscribe({
          next: (res: any) => {
            if (res.isSuccess) {
              this.profileImageUrl = res.item.url;
            }
          },
          error: (error: any) => { console.log(error) }
        })
      }
      fileInput.value = '';
      console.log(file)
    }
  }
}
